import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_SEARCH_IMAGING_TESTS } from "../../action-types/actions";

import i18n from "../../i18n";
export const searchImagingTests = createAsyncThunk(
  ACTIONS_SEARCH_IMAGING_TESTS.search_imaging_tests,
  async ({ search = "" }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      if (!search || search.trim() === "") {
        return rejectWithValue(i18n.t("toast.searchQueryIsRequired"));
      }

      const queryParams = new URLSearchParams({
        search: search.trim(),
      });

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.searchImagingTests}?${queryParams.toString()}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorSearchingImagingTests");
      return rejectWithValue(errMsg);
    }
  },
);
